import { render, staticRenderFns } from "./GradientDonutMulti.vue?vue&type=template&id=4946f426&scoped=true&"
import script from "./GradientDonutMulti.vue?vue&type=script&lang=js&"
export * from "./GradientDonutMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4946f426",
  null
  
)

export default component.exports